module.exports = __webpack_public_path__ + "img/Middle-Horizontal-Rectangular-Attachment-27.f27d2486.png";